import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createReturnReasonConfigBottom, createReturnReasonConfigTop } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Pattern dress - Pink.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Pink",
                        },
                        {
                            type: "Size",
                            value: "86",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Pattern dress - White.png",
                    inventoryMerchant: 2,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "86",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Pattern dress - White.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "92",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Pattern dress - White.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "98",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Socks - White.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "22-24",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Socks - White.png",
                    inventoryMerchant: 0,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "25-27",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Socks - White.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "28-30",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Socks - Pink.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Pink",
                        },
                        {
                            type: "Size",
                            value: "22-24",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Jacket - Beige.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Beige",
                        },
                        {
                            type: "Size",
                            value: "86",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Jacket - Green.png",
                    inventoryMerchant: 2,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Green",
                        },
                        {
                            type: "Size",
                            value: "86",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Jacket - Green.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Green",
                        },
                        {
                            type: "Size",
                            value: "92",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Jacket - Green.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Green",
                        },
                        {
                            type: "Size",
                            value: "98",
                        },
                    ],
                },
            ],
        };
    }
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        paidShipping: 4,
        turnrShippingCost: 5,
        currencyCode: "GBP",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "Pattern dress",
                imageSrc: "/mocks/Pattern dress - Pink.png",
                imageAlt: "/mocks/Pattern dress - Pink.png",
                quantity: 1,
                purchasePrice: 40,
                properties: [
                    {
                        type: "Size",
                        value: "92",
                    },
                    {
                        type: "Color",
                        value: "Pink",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
            {
                productVariantId: 20,
                sessionItemId: 2,
                productName: "Socks, 2 pack",
                imageSrc: "/mocks/Socks - Pink.png",
                imageAlt: "/mocks/Socks - Pink.png",
                quantity: 1,
                purchasePrice: 8,
                properties: [
                    {
                        type: "Color",
                        value: "Pink",
                    },
                    {
                        type: "Size",
                        value: "25-27",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigBottom(),
            },
            {
                productVariantId: 30,
                sessionItemId: 3,
                productName: "Floral print jacket",
                imageSrc: "/mocks/Jacket - Beige.png",
                imageAlt: "/mocks/Jacket - Beige.png",
                quantity: 1,
                purchasePrice: 40,
                properties: [
                    {
                        type: "Size",
                        value: "92",
                    },
                    {
                        type: "Color",
                        value: "Beige",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
        ],
    };
}
